import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { IconButton } from "@mui/material";
import { auth, firestore } from "firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { updateDoc, doc } from "firebase/firestore";
import Divider from "@mui/material/Divider";

function Consultoria() {
  const [tabIndex, setTabIndex] = useState(0);
  const [recomendacoes, setRecomendacoes] = useState([]);
  const [reunioes, setReunioes] = useState([]);
  const [relatorios, setRelatorios] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Verifica se o usuário está autenticado

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // Função para buscar os dados do cliente no Firestore
  const fetchData = async () => {
    const user = auth.currentUser;

    if (!user) {
      console.error("Usuário não autenticado.");
      setIsAuthenticated(false);
      return;
    }
    setIsAuthenticated(true);

    try {
      console.log(`Buscando dados para o usuário com UID: ${user.uid}`);

      // Referência à subcoleção 'consultor' do cliente logado
      const consultoriasRef = collection(firestore, `usuarios/${user.uid}/consultor`);
      const snapshot = await getDocs(consultoriasRef);

      if (snapshot.empty) {
        console.warn("Nenhum dado encontrado na subcoleção 'consultor'.");
        return;
      }

      // Organiza os dados por tipo
      const relatorios = [];
      const reunioes = [];
      const recomendacoes = [];

      snapshot.forEach((doc) => {
        const data = doc.data();
        console.log(`Documento encontrado: ${doc.id}`, data);

        // Verifique o campo 'clienteId' apenas se ele existir ou remova o filtro, dependendo da lógica necessária
        if (!data.clienteId || data.clienteId === user.uid) {
          const item = { id: doc.id, lido: data.lido || false, ...data }; // Garante que 'lido' esteja presente

          switch (data.tipo) {
            case "relatorio":
              relatorios.push(item); // Inclui o campo 'lido' nos relatórios, caso necessário
              break;
            case "reuniao":
              reunioes.push(item); // Inclui o campo 'lido' nas reuniões, caso necessário
              break;
            case "recomendacao":
              recomendacoes.push(item); // Inclui o campo 'lido' nas recomendações
              break;
            default:
              console.warn("Tipo desconhecido:", data.tipo);
              break;
          }
        } else {
          console.warn(
            `Documento ${doc.id} ignorado: clienteId (${data.clienteId}) não corresponde ao UID do cliente (${user.uid}).`
          );
        }
      });

      // Atualiza os estados
      setRelatorios(relatorios);
      setReunioes(reunioes);
      setRecomendacoes(recomendacoes);
    } catch (error) {
      console.error("Erro ao buscar dados do Firestore:", error.message);
    }
  };

  // Carrega os dados ao montar o componente
  useEffect(() => {
    fetchData();
  }, []);

  // Renderização condicional das seções
  const renderConsultoriaSection = () => {
    if (!isAuthenticated) {
      return (
        <Card>
          <MDBox p={3}>
            <MDTypography variant="h5" color="error">
              Usuário não autenticado. Faça login novamente.
            </MDTypography>
          </MDBox>
        </Card>
      );
    }

    switch (tabIndex) {
      case 0: // Relatórios
        return (
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h5">Relatórios</MDTypography>
              <MDBox mt={2}>
                {relatorios.length > 0 ? (
                  <ul>
                    {relatorios.map((relatorio, index) => (
                      <li key={index}>
                        <a href={relatorio.conteudo} target="_blank" rel="noopener noreferrer">
                          Acessar Relatório
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <MDTypography>Você ainda não recebeu relatórios.</MDTypography>
                )}
              </MDBox>
            </MDBox>
          </Card>
        );

      case 1: // Reuniões
        return (
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h5" fontWeight="bold" gutterBottom>
                Reuniões
              </MDTypography>
              <MDBox mt={3}>
                {reunioes.length > 0 ? (
                  Object.entries(
                    reunioes.reduce((acc, reuniao) => {
                      const mes = new Date(reuniao.data).toLocaleDateString("pt-BR", {
                        month: "long",
                      });
                      acc[mes] = acc[mes] || [];
                      acc[mes].push(reuniao);
                      return acc;
                    }, {})
                  ).map(([mes, reunioesMes], index) => (
                    <MDBox key={index} mb={4}>
                      <MDTypography
                        variant="h6"
                        color="info"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ textTransform: "capitalize" }}
                      >
                        {mes}
                      </MDTypography>
                      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {reunioesMes.map((reuniao, idx) => {
                          const dataAgendada = new Date(reuniao.data);
                          const dataFormatada = dataAgendada.toLocaleDateString("pt-BR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          });
                          const horaFormatada = dataAgendada.toLocaleTimeString("pt-BR", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          });

                          return (
                            <li
                              key={idx}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "16px",
                                borderBottom: idx < reunioesMes.length - 1 ? "1px solid #ddd" : "none",
                                paddingBottom: "8px",
                              }}
                            >
                              {/* Conteúdo da reunião */}
                              <MDBox>
                                <MDTypography variant="subtitle2" color="text" fontWeight="bold" mb={1}>
                                  {dataFormatada} às {horaFormatada}
                                </MDTypography>
                                <MDTypography variant="body1">{reuniao.conteudo || "Sem detalhes"}</MDTypography>
                              </MDBox>

                              {/* Botão de status */}
                              <IconButton
                                onClick={() => {
                                  setReunioes((prev) =>
                                    prev.map((r) => (r.id === reuniao.id ? { ...r, lido: !r.lido } : r))
                                  );
                                }}
                              >
                                {reuniao.lido ? (
                                  <CheckCircleIcon color="success" />
                                ) : (
                                  <RadioButtonUncheckedIcon style={{ color: "gray" }} />
                                )}
                              </IconButton>
                            </li>
                          );
                        })}
                      </ul>
                    </MDBox>
                  ))
                ) : (
                  <MDTypography color="textSecondary" textAlign="center">
                    Você ainda não possui reuniões agendadas.
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>
          </Card>
        );

      case 2: // Recomendações
        return (
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h5" mb={2}>
                Recomendações
              </MDTypography>

              {/* Pendentes */}
              <MDBox mt={3}>
                <MDTypography variant="h6" color="error" mb={2}>
                  Pendentes
                </MDTypography>
                {recomendacoes.filter((rec) => !rec.lido).length > 0 ? (
                  Object.entries(
                    recomendacoes
                      .filter((rec) => !rec.lido) // Apenas os pendentes
                      .reduce((acc, recomendacao) => {
                        const mesAno = new Date(recomendacao.data).toLocaleDateString("pt-BR", {
                          month: "long",
                          year: "numeric",
                        });
                        acc[mesAno] = acc[mesAno] || [];
                        acc[mesAno].push(recomendacao);
                        return acc;
                      }, {})
                  ).map(([mesAno, recomendacoesMes], groupIndex) => (
                    <MDBox key={groupIndex} mb={3}>
                      <MDTypography variant="h6" color="text" mb={2} sx={{ textTransform: "capitalize" }}>
                        {mesAno}
                      </MDTypography>
                      <Card sx={{ p: 2, boxShadow: 2 }}>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                          {recomendacoesMes.map((recomendacao, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "16px",
                                borderBottom: index < recomendacoesMes.length - 1 ? "1px solid #ddd" : "none",
                                paddingBottom: "8px",
                              }}
                            >
                              <MDBox>
                                <MDTypography variant="subtitle2" color="text" fontWeight="bold" mb={1}>
                                  {new Date(recomendacao.data).toLocaleDateString("pt-BR")}
                                </MDTypography>
                                <MDTypography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                                  {recomendacao.conteudo}
                                </MDTypography>
                              </MDBox>
                              <IconButton
                                onClick={() => {
                                  setRecomendacoes((prev) =>
                                    prev.map((r) => (r.id === recomendacao.id ? { ...r, lido: true } : r))
                                  );
                                }}
                              >
                                <RadioButtonUncheckedIcon style={{ color: "gray" }} />
                              </IconButton>
                            </li>
                          ))}
                        </ul>
                      </Card>
                    </MDBox>
                  ))
                ) : (
                  <MDTypography>Sem recomendações pendentes.</MDTypography>
                )}
              </MDBox>

              {/* Lidas */}
              <MDBox mt={3}>
                <MDTypography variant="h6" color="textSecondary" mb={2}>
                  Lidas
                </MDTypography>
                {recomendacoes.filter((rec) => rec.lido).length > 0 ? (
                  Object.entries(
                    recomendacoes
                      .filter((rec) => rec.lido) // Apenas os lidos
                      .reduce((acc, recomendacao) => {
                        const mesAno = new Date(recomendacao.data).toLocaleDateString("pt-BR", {
                          month: "long",
                          year: "numeric",
                        });
                        acc[mesAno] = acc[mesAno] || [];
                        acc[mesAno].push(recomendacao);
                        return acc;
                      }, {})
                  ).map(([mesAno, recomendacoesMes], groupIndex) => (
                    <MDBox key={groupIndex} mb={3}>
                      <MDTypography variant="h6" color="text" mb={2} sx={{ textTransform: "capitalize" }}>
                        {mesAno}
                      </MDTypography>
                      <Card sx={{ p: 2, boxShadow: 2 }}>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                          {recomendacoesMes.map((recomendacao, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "16px",
                                borderBottom: index < recomendacoesMes.length - 1 ? "1px solid #ddd" : "none",
                                paddingBottom: "8px",
                              }}
                            >
                              <MDBox>
                                <MDTypography variant="subtitle2" color="text" fontWeight="bold" mb={1}>
                                  {new Date(recomendacao.data).toLocaleDateString("pt-BR")}
                                </MDTypography>
                                <MDTypography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                                  {recomendacao.conteudo}
                                </MDTypography>
                              </MDBox>
                              <IconButton
                                onClick={() => {
                                  setRecomendacoes((prev) =>
                                    prev.map((r) => (r.id === recomendacao.id ? { ...r, lido: false } : r))
                                  );
                                }}
                              >
                                <CheckCircleIcon color="success" />
                              </IconButton>
                            </li>
                          ))}
                        </ul>
                      </Card>
                    </MDBox>
                  ))
                ) : (
                  <MDTypography>Nenhuma recomendação lida.</MDTypography>
                )}
              </MDBox>
            </MDBox>
          </Card>
        );

      default:
        return null;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox p={3}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          centered
          variant="fullWidth"
          sx={{
            // container das abas (trilho)
            p: 0.5,
            mx: "auto",
            width: { xs: "100%", sm: "auto" },
            borderRadius: 9999,
            background: "rgba(255,255,255,0.65)",
            border: "1px solid rgba(30,136,229,0.15)", // azul bem suave
            boxShadow: "0 6px 18px rgba(30,136,229,0.08)",
            backdropFilter: "saturate(180%) blur(8px)",
            "& .MuiTabs-indicator": { display: "none" }, // sem linha
            // cada aba
            "& .MuiTab-root": {
              minHeight: 40,
              borderRadius: 9999,
              textTransform: "none",
              fontWeight: 700,
              fontSize: { xs: "0.9rem", md: "1rem" },
              px: { xs: 1.5, md: 2.5 },
              color: "#5E7FA3", // cinza-azulado para melhor leitura
              transition: "all .2s ease",
              "&:hover": {
                backgroundColor: "rgba(221,241,255,0.7)",
              },
              "&.Mui-selected": {
                color: "#1565D8", // azul do título, forte porém legível
                background: "linear-gradient(180deg, #E6F5FF 0%, #F4FAFF 100%)",
                border: "1px solid #BFE7FF",
                boxShadow: "0 6px 14px rgba(21,101,216,0.12), inset 0 -2px 0 rgba(21,101,216,0.06)",
              },
            },
          }}
        >
          <Tab label="Relatórios" />
          <Tab label="Reuniões" />
          <Tab label="Recomendações" />
        </Tabs>
        <Divider />
        <MDBox mt={3}>{renderConsultoriaSection()}</MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Consultoria;
